import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { InvoiceModel } from '@data-layer/models/entry-summaries';
import { EntityModel } from '@data-layer/models/entities';
import { UntypedFormGroup } from '@angular/forms';
import { CurrencyModel, IncoTermModel } from '@data-layer/models/common';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { ReplaySubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { EntrySummaryStateService } from '@shared/es-mutual/services';

@Component({
  selector: 'es-details-invoice-ocr-card-form-desktop',
  templateUrl: './es-details-invoice-ocr-card-form-desktop.component.html',
  styleUrls: ['./es-details-invoice-ocr-card-form-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsDetailsInvoiceOcrCardFormDesktopComponent implements OnInit, OnDestroy {
  @Input() public invoice: InvoiceModel;
  @Input() public fg: UntypedFormGroup;
  @Input() public billOfLadingId: number;
  @Input() public currencies: CurrencyModel[];
  @Input() public currencyRate: number = 1;
  @Input() public incoterms: IncoTermModel[];
  @Output() public editMF: EventEmitter<void> = new EventEmitter<void>();
  @Output() public saveInvoice: EventEmitter<void> = new EventEmitter<void>();

  public manufacturer: EntityModel;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private entrySummaryStateService: EntrySummaryStateService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    // Due to big prop drilling data is stuck somewhere at top old levels
    this.entrySummaryStateService.forceDataReload$
      .pipe(
        filter((data: boolean) => !!data),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.manufacturer = this.fg.get('manufacturer')?.value || new EntityModel({ entityCode: enumEntityModelCode.MANUFACTURER });
        this.cdr.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public get manufacturerEntity(): EntityModel {
    return !!this.fg.get('manufacturer')?.value?.entityCode ? this.manufacturer : null;
  }
}
